import cx from 'classnames';
import React from 'react';
import { BaseSelector, SwatchShapeOptions, } from '../base/base-selector';
import styles from './color.module.scss';
export var BorderStyle;
(function (BorderStyle) {
    BorderStyle["SOLID"] = "solid";
})(BorderStyle || (BorderStyle = {}));
export const Color = ({ selectedOption = '', swatchShape, showBorder = false, tabIndex = 0, border = undefined, ...restProps }) => {
    const selectValueClass = cx(styles.selectedValue, styles.selectedColor, {
        [styles.swatchRound]: swatchShape === SwatchShapeOptions.ROUND,
        [styles.swatchRoundLarge]: swatchShape === SwatchShapeOptions.ROUND_LARGE,
        [styles.border]: showBorder,
        [styles.selectedEmptyColor]: selectedOption === '',
    });
    const baseSelectorStyles = {};
    if (border) {
        baseSelectorStyles.border = `${border.width}px ${border.style} ${border.color}`;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseSelector, { swatchShape: swatchShape, ...restProps, tabIndex: tabIndex },
            React.createElement("div", { className: selectValueClass, style: {
                    backgroundColor: selectedOption,
                    ...baseSelectorStyles,
                }, "data-testid": "base-selector-div-testid" }))));
};
//# sourceMappingURL=color.js.map